import { useState } from 'react';
import PolicyPriceInfoView from '@/dashboard/components/Products/policyCard/components/policyProductInfo/components//policyPriceInfo';
import PolicyCoverageListInfoView from '@/dashboard/components/Products/policyCard/components/policyProductInfo/components/coverageInfo';
import { Box, Typography } from '@mui/material';
import PolicyPaymentScheduleWithUnConfirmView from 'libs/uikit/src/ui/policy/paymentScheduleWithUnconfirm';

export interface PolicyCoverageAndPriceViewProps {
  coverList?: Array<{
    title: string;
    content: string;
  }>;
  priceList?: Array<{
    title: string;
    content: string;
    isPaymentPlan?: boolean;
    isBoldMore?: boolean;
  }>;
  paymentScheduleList?: any[];
  showPaymentSchedule?: boolean;
  hidePaymentScheduleColumnList?: string[];
  unconfirmedPaymentInfoList?: any[];
}
const PolicyCoverageAndPriceView = (props: PolicyCoverageAndPriceViewProps) => {
  const { coverList, priceList, paymentScheduleList, hidePaymentScheduleColumnList, unconfirmedPaymentInfoList } = props;
  const [coverInfoList, setCoverInfoList] = useState(coverList || []);
  const [priceInfoList, setPriceInfoList] = useState(priceList || []);
  const [combinePaymentScheduleList, setCombinePaymentScheduleList] = useState([]);

  /**
   * methods
   */
  const combinePaymentListChangeAction = (list) => {
    setCombinePaymentScheduleList(list);
  };

  return (
    <Box className="flex flex-col space-y-3">
      <PolicyCoverageListInfoView list={coverInfoList} />
      {priceInfoList.length > 0 && <PolicyPriceInfoView list={priceInfoList} />}
      <Box className="flex flex-col">
        {combinePaymentScheduleList.length > 0 && (
          <Typography variant="subtitle1" className="font-bold">
            Payment schedule
          </Typography>
        )}
        <PolicyPaymentScheduleWithUnConfirmView
          onlyDisplayPendingPayment
          scheduleList={paymentScheduleList}
          unconfirmList={unconfirmedPaymentInfoList}
          valueChange={combinePaymentListChangeAction}
        />
      </Box>
    </Box>
  );
};

export default PolicyCoverageAndPriceView;
